module.exports = __webpack_public_path__ + "img/icon-list-error.930725cd.png";